import type { ReactNode } from "react"
import { SelectInput } from "@ui/forms/inputs/select-input"
import { Label, Textarea } from "@ui/shad"

import {
  MilestoneFormFieldsInput,
  type FileAttachmentScope,
  type HouseholdRecordScope,
  type MilestoneFormField,
} from "./milestone-form-fields-input"

interface OutcomeFormContentProps {
  description: ReactNode
  outcomeOptions: { value: string; label: ReactNode; triggerLabel?: string }[]
  selectedOutcomeId: string
  onOutcomeChange: (id: string) => void
  commentText: string
  onCommentChange: (text: string) => void
  formFields: MilestoneFormField[]
  formFieldsHeader: string
  formResponses: Record<string, string | number | boolean | null>
  onFormResponsesChange: (responses: Record<string, string | number | boolean | null>) => void
  disabled: boolean
  selectId: string
  commentId: string
  householdRecordScope?: HouseholdRecordScope
  fileAttachmentScope?: FileAttachmentScope
}

export function OutcomeFormContent({
  description,
  outcomeOptions,
  selectedOutcomeId,
  onOutcomeChange,
  commentText,
  onCommentChange,
  formFields,
  formFieldsHeader,
  formResponses,
  onFormResponsesChange,
  disabled,
  selectId,
  commentId,
  householdRecordScope,
  fileAttachmentScope,
}: OutcomeFormContentProps) {
  const hasFormFields = formFields.length > 0

  return (
    <div className={`grid gap-6 [&>*]:min-w-0 ${hasFormFields ? "md:grid-cols-2" : ""}`}>
      <div className="space-y-4">
        {description}
        <div className="space-y-2">
          <Label htmlFor={selectId}>Outcome</Label>
          <SelectInput
            id={selectId}
            value={selectedOutcomeId}
            onChange={onOutcomeChange}
            options={outcomeOptions}
            disabled={disabled}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor={commentId}>Comment (optional)</Label>
          <Textarea
            id={commentId}
            value={commentText}
            onChange={(event) => onCommentChange(event.target.value)}
            placeholder="Add a project comment"
            rows={3}
            disabled={disabled}
          />
        </div>
      </div>
      {hasFormFields && (
        <div className="animate-in fade-in slide-in-from-right-2 border-border space-y-2 rounded-md border p-3 duration-200">
          <p className="text-muted-foreground text-xs font-medium">{formFieldsHeader}</p>
          <MilestoneFormFieldsInput
            fields={formFields}
            values={formResponses}
            onChange={onFormResponsesChange}
            disabled={disabled}
            householdRecordScope={householdRecordScope}
            fileAttachmentScope={fileAttachmentScope}
          />
        </div>
      )}
    </div>
  )
}
